import { computed, ref } from '@vue/composition-api'
import jwt from '@/auth/jwt/useJwt'

export default function DomainItem(apiURL) {
  const initialItem = computed(() => ({
    status: true,
  }))

  const item = ref({ ...initialItem.value })

  const getItemsRequest = params => jwt.axiosIns.get(apiURL, { params }).then(res => res).catch(() => [])

  const addItemRequest = () => jwt.axiosIns.post(apiURL, item.value).then(res => res)

  const updateItemRequest = () => jwt.axiosIns.put(`${apiURL}/${item.value.id}`, item.value).then(res => res)

  const toggleStatus = selectedItem => jwt.axiosIns.put(`${apiURL}/${selectedItem.id}/status`).then(res => res)

  const resetItem = () => {
    item.value = { ...initialItem.value }
  }
  return {
    item, initialItem, getItemsRequest, addItemRequest, updateItemRequest, resetItem, toggleStatus,
  }
}
